import {get} from "lodash"
import BaseService from "./Base"

class CourseCategoryService extends BaseService {
    async getAllCourseCategories() {
        const response = await this.post("/v1/course-categories/list", {})
        return get(response, "data", [])
    }
}

export default CourseCategoryService
